/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectRoleDTO } from './ProjectRoleDTO';
import {
    ProjectRoleDTOFromJSON,
    ProjectRoleDTOFromJSONTyped,
    ProjectRoleDTOToJSON,
} from './ProjectRoleDTO';

/**
 * 
 * @export
 * @interface OrganizationInvitationProjectEntryDTO
 */
export interface OrganizationInvitationProjectEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationInvitationProjectEntryDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInvitationProjectEntryDTO
     */
    name: string;
    /**
     * 
     * @type {ProjectRoleDTO}
     * @memberof OrganizationInvitationProjectEntryDTO
     */
    role: ProjectRoleDTO;
}



/**
 * Check if a given object implements the OrganizationInvitationProjectEntryDTO interface.
 */
export function instanceOfOrganizationInvitationProjectEntryDTO(value: object): value is OrganizationInvitationProjectEntryDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function OrganizationInvitationProjectEntryDTOFromJSON(json: any): OrganizationInvitationProjectEntryDTO {
    return OrganizationInvitationProjectEntryDTOFromJSONTyped(json, false);
}

export function OrganizationInvitationProjectEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationInvitationProjectEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'role': ProjectRoleDTOFromJSON(json['role']),
    };
}

export function OrganizationInvitationProjectEntryDTOToJSON(value?: OrganizationInvitationProjectEntryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'role': ProjectRoleDTOToJSON(value['role']),
    };
}

